import './styles/index.scss';
import { graphql, PageProps } from 'gatsby';
import React, { useContext, useEffect, useState } from 'react';
import {
    Dropdown,
    EnglanderButton,
    ImageBlock,
    PageTitle,
    SingleBlog,
} from '../components/Primitives';

import { ApplianceSingle } from '../components/Listing';
import CategoryArchiveComponent from '../components/Primitives/CategoryArchiveComponent';
import IconSearch from '@progymedia/sbi-web-englander/src/images/englander-icons/Search-Icon.svg';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import circleEmpty from '@progymedia/sbi-web-englander/src/images/englander-icons/Cercle-Gris.png';
import circleFull from '@progymedia/sbi-web-englander/src/images/englander-icons/Cercle-Rouge.png';
import { feedbackContext } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/feedback/feedbackContext';

import iconHelp from '@progymedia/sbi-web-englander/src/images/englander-icons/Icon-Help.svg';
import leftArrowIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Left-Short-Arrow-Icon.svg';
import { replaceWhiteSpace } from '@progymedia/sbi-web-englander/src/utils';
import rightArrowIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Right-Short-Arrow-Icon.svg';
import rightArrowIconLong from '@progymedia/sbi-web-englander/src/images/englander-icons/Right-Arrow-Icon.svg';
import storeIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Store-Icon.svg';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query IndexPage {
        metadata: allProductsJson(
            filter: { code: { eq: "englander_accueil" } }
        ) {
            nodes {
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        sliders: allProductsJson(
            filter: { code: { regex: "/^englander_accueil-slider/" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                description {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    ...productsFieldsImagesFragment
                }
                attributes {
                    texte_1 {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    texte_2 {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    texte_3 {
                        values {
                            fr_CA
                            en_US
                            en_CA
                        }
                    }
                    bouttons {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    url {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        heaterCategories: allProductsJson(
            filter: { code: { eq: "englander_category-heaters" } }
        ) {
            nodes {
                images {
                    en_CA
                    en_US
                    fr_CA
                    caption {
                        en_CA
                        en_US
                        fr_CA
                    }
                }
                fields {
                    ...productsFieldsImagesFragment
                }
            }
        }
        bestSellers: allProductsJson(
            filter: { code: { eq: "englander_accueil-best-sellers" } }
        ) {
            nodes {
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    suggested_appliances {
                        values {
                            en_CA
                        }
                    }
                }
            }
        }
        allProducts: allProductsJson(
            filter: {
                category: { regex: "^/Englander/Heaters/" }
                status: { eq: "actif" }
            }
        ) {
            nodes {
                code
                slug {
                    en_CA
                    en_US
                    fr_CA
                }
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                category
                category_localized {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    certifications {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    size {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
                images {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    ...productsFieldsImagesFragment
                }
            }
        }
        ourPromotions: allProductsJson(
            filter: { code: { eq: "englander_accueil-our-promotions" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                description {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    ...productsFieldsImagesFragment
                }
                attributes {
                    texte_1 {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        blogs: allProductsJson(
            filter: { category: { eq: "/Englander/CMS/Blog/" } }
            limit: 3
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    content {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    blog_subject {
                        group
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    recent_article {
                        values {
                            fr_CA
                            en_CA
                            en_US
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
                fields {
                    ...productsFieldsImagesFragment
                }
                slug {
                    en_CA
                    en_US
                    fr_CA
                }
            }
        }
    }
`;

export default function IndexPage({ data }: PageProps<Queries.IndexPageQuery>) {
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const { t } = useTranslation('pages');
    const SCREEN_SLIDER_TRIGGER = 100;
    const metadataAttributes = data?.metadata?.nodes[0]?.attributes;
    const isMobile = useMobileDetect().isMobile();
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };
    const { addAlert } = useContext(feedbackContext);

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />
            <div className='home-page container'>
                <Slider />
                <PerfectDevice />
                <ShopByCategory />
                <FindReplacementPart />
                <FindRetailer />
                <BestSellers />
                <OurPromotions />
                <TipsAndTricks />
                <OwnerOfEnglander />
            </div>
        </Layout>
    );

    function Slider() {
        const sliders = data.sliders.nodes;

        const [sliderPos, setSliderPos] = useState(0);
        const [startSwipe, setStartSwipe] = useState(0);
        const [endSwipe, setEndSwipe] = useState(0);

        const mainBlogActionButton = {
            title: sliders?.[sliderPos]?.attributes?.bouttons?.values?.[0]?.[
                currentLocale
            ],
            hasArrow: true,
            onClick: () =>
                navigateTranslated(
                    sliders?.[sliderPos]?.attributes?.url?.values?.[0]?.[
                        currentLocale
                    ]
                ),
        };

        function handleSwipe() {
            if (endSwipe - startSwipe > SCREEN_SLIDER_TRIGGER) {
                if (sliderPos - 1 >= 0) setSliderPos(sliderPos - 1);
            }
            if (endSwipe - startSwipe < -SCREEN_SLIDER_TRIGGER) {
                if (sliderPos + 1 < sliders.length) setSliderPos(sliderPos + 1);
            }
        }
        useEffect(() => {
            handleSwipe();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [endSwipe]);
        return (
            <div
                className='slider-functions'
                onTouchStart={(e) => {
                    setStartSwipe(e?.changedTouches[0].screenX);
                }}
                onTouchEnd={(e) => {
                    setEndSwipe(e?.changedTouches[0].screenX);
                }}
            >
                <ImageBlock
                    title={sliders?.[sliderPos].title?.[currentLocale]}
                    content={sliders?.[sliderPos]?.description?.[currentLocale]}
                    image={
                        sliders?.[sliderPos]?.fields?.images?.[0]
                            ?.childImageSharp?.gatsbyImageData
                    }
                    button={mainBlogActionButton}
                    imageTitleTop={
                        sliders?.[sliderPos].attributes?.texte_1?.values?.[0]?.[
                            currentLocale
                        ]
                    }
                    imageTitleBottom={
                        sliders?.[sliderPos].attributes?.texte_2?.values?.[0]?.[
                            currentLocale
                        ]
                    }
                />
                <img
                    className='slider-arrow left'
                    src={leftArrowIcon}
                    alt='<'
                    onClick={() => {
                        if (sliderPos - 1 >= 0) {
                            setSliderPos(sliderPos - 1);
                        } else setSliderPos(sliders.length - 1);
                    }}
                />
                <img
                    className='slider-arrow right'
                    src={rightArrowIcon}
                    alt='>'
                    onClick={() => {
                        if (sliderPos + 1 < sliders.length) {
                            setSliderPos(sliderPos + 1);
                        } else setSliderPos(0);
                    }}
                />
                <div className='slider-circle'>
                    {sliders.map((_: any, index: number) => {
                        return (
                            <img
                                src={
                                    index === sliderPos
                                        ? circleFull
                                        : circleEmpty
                                }
                                key={`circle-${index}`}
                                onClick={() => setSliderPos(index)}
                                alt=''
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    function PerfectDevice() {
        const categoryElements = [
            {
                label: t('layout:header.wood-stoves'),
                value: '/heaters/wood-stoves/',
            },
            {
                label: t('layout:header.pellet-stoves'),
                value: '/heaters/pellet-stoves/',
            },
            {
                label: t('layout:header.wood-inserts'),
                value: '/heaters/wood-inserts/',
            },
        ];

        const surfiElements = [
            {
                label: t('archives.surfi-fromto', { from: 0, to: 999 }),
                value: 'surfi=0-999',
            },
            {
                label: t('archives.surfi-fromto', { from: 1000, to: 1999 }),
                value: 'surfi=1000-1999',
            },
            {
                label: t('archives.surfi-fromto', { from: 2000, to: 2999 }),
                value: 'surfi=2000-2999',
            },
            {
                label: t('archives.surfi-fromto', { from: 3000, to: 4000 }),
                value: 'surfi=3000-4000',
            },
        ];

        const [categoryDropdownValue, setCategoryDropdownValue] =
            useState<string>();
        const [surfiDropdownValue, setHeatingDropdownValue] =
            useState<string>();
        return (
            <div className='perfect-device'>
                <div className='perfect-title'>
                    <h2>{t('home.find-perfect-device')}</h2>
                </div>
                <div className='select-device'>
                    <Dropdown
                        title={t('home.category')}
                        elements={categoryElements}
                        setCurrentValue={setCategoryDropdownValue}
                    />
                    <Dropdown
                        title={t('home.heating-area')}
                        iconLeft={iconHelp}
                        elements={surfiElements}
                        setCurrentValue={setHeatingDropdownValue}
                        className='heating-dropdown'
                    />
                    <EnglanderButton
                        label={t('archives.search')}
                        iconRight={rightArrowIconLong}
                        className='find-device-button'
                        onClick={() => {
                            if (!categoryDropdownValue) {
                                addAlert({
                                    message: t('pages:error.category-required'),
                                    status: 'error',
                                });
                            } else {
                                navigateTranslated(
                                    `${categoryDropdownValue}?${
                                        surfiDropdownValue
                                            ? surfiDropdownValue
                                            : ''
                                    }`
                                );
                            }
                        }}
                    />
                </div>
            </div>
        );
    }

    function ShopByCategory() {
        const captions = data?.heaterCategories?.nodes?.[0]?.images
            ?.filter((d) => d?.caption?.en_CA != 'Pellet Stoves')
            .map((e: any, index: number) => {
                return {
                    ...e,
                    index,
                };
            });

        return (
            <div className='show-by-category-container'>
                <PageTitle notHeader title={t('home.category-shop')} />
                <CategoryArchiveComponent
                    images={
                        data?.heaterCategories?.nodes?.[0]?.fields
                            ?.images as any
                    }
                    captions={
                        captions?.filter(
                            (d: any) => d?.caption?.en_CA != 'Pellet Stoves'
                        ) as any[]
                    }
                    category={'heaters'}
                />
            </div>
        );
    }

    function FindReplacementPart() {
        const [searchValue, setSearchValue] = useState('');
        const verifyAndNavigate = () => {
            if (searchValue.trim() === '') {
                addAlert({
                    message: t('pages:error.field-required'),
                    status: 'error',
                });
            } else {
                navigateTranslated(`/archives/?s=${searchValue}`);
            }
        };
        return (
            <div className='find-replacement-part'>
                <div className='search-block-replacement'>
                    <h1 className='find-replacement-retailer'>
                        {t('home.find-replacement')}
                    </h1>
                    <p className='enter-informations-retailer'>
                        {t('home.enter-informations')}
                    </p>
                    <div className='input-container'>
                        <input
                            className='input-replacement'
                            placeholder={t('home.retailer-placeholder')}
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    verifyAndNavigate();
                                }
                            }}
                        />
                        <EnglanderButton
                            label={t('archives.search')}
                            iconRight={IconSearch}
                            className='btn-replacement-retailer'
                            onClick={verifyAndNavigate}
                        />
                    </div>
                </div>
            </div>
        );
    }

    function FindRetailer() {
        const [zipcodeValue, setZipCodeValue] = useState('');
        const verifyAndNavigate = () => {
            const zipCode = replaceWhiteSpace(zipcodeValue, '');
            if (zipCode === '') {
                addAlert({
                    message: t('pages:error.field-required'),
                    status: 'error',
                });
            } else {
                navigateTranslated(`/where-to-buy/?searchValue=${zipCode}`);
            }
        };
        return (
            <div className='find-retailer-section'>
                <div className='left-section'>
                    <img src={storeIcon} alt='home' />
                    <h2 className='retailer-title'>
                        {t('home.find-retailer-near')}
                    </h2>
                </div>
                <div className='right-section'>
                    <input
                        className='input-retailer'
                        placeholder={t('where-to-buy.postcode')}
                        value={zipcodeValue}
                        onChange={(e) => setZipCodeValue(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                verifyAndNavigate();
                            }
                        }}
                    />
                    <EnglanderButton
                        label={t('home.enter')}
                        iconRight={rightArrowIconLong}
                        className='btn-replacement-retailer'
                        onClick={verifyAndNavigate}
                    />
                </div>
            </div>
        );
    }

    function BestSellers() {
        const bestSellersCms = data?.bestSellers?.nodes?.[0];
        const allProducts = data?.allProducts?.nodes;
        const appliances = allProducts.filter((e: any) =>
            bestSellersCms?.attributes?.suggested_appliances?.values
                .map((ee: any) => ee.en_CA?.trim())
                .includes(e.code)
        );
        const [sellerSliderPos, setSellerSliderPos] = useState(0);
        const [sellerStartSwipe, setSellerStartSwipe] = useState(0);
        const [sellerEndSwipe, setSellerEndSwipe] = useState(0);

        function handleSellerSwipe() {
            if (sellerEndSwipe - sellerStartSwipe > SCREEN_SLIDER_TRIGGER) {
                if (sellerSliderPos - 1 >= 0)
                    setSellerSliderPos(sellerSliderPos - 1);
            }
            if (sellerEndSwipe - sellerStartSwipe < -SCREEN_SLIDER_TRIGGER) {
                if (sellerSliderPos + 1 < appliances.length)
                    setSellerSliderPos(sellerSliderPos + 1);
            }
        }
        useEffect(() => {
            handleSellerSwipe();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [sellerEndSwipe]);
        return (
            <div className='best-sellers-container'>
                <PageTitle
                    notHeader
                    title={bestSellersCms?.title?.[currentLocale]}
                />
                <div
                    className='best-seller-appliances'
                    onTouchStart={(e) => {
                        setSellerStartSwipe(e?.changedTouches[0].screenX);
                    }}
                    onTouchEnd={(e) => {
                        setSellerEndSwipe(e?.changedTouches[0].screenX);
                    }}
                >
                    {appliances.map((single: any, index: number) => {
                        if (isMobile && index !== sellerSliderPos) return;
                        return (
                            <ApplianceSingle
                                key={single?.code + index}
                                appliance={single}
                            />
                        );
                    })}
                    {isMobile && (
                        <>
                            <img
                                className='slider-arrow left'
                                src={leftArrowIcon}
                                alt='<'
                                onClick={() => {
                                    if (sellerSliderPos - 1 >= 0) {
                                        setSellerSliderPos(sellerSliderPos - 1);
                                    } else
                                        setSellerSliderPos(
                                            appliances.length - 1
                                        );
                                }}
                            />
                            <img
                                className='slider-arrow right'
                                src={rightArrowIcon}
                                alt='>'
                                onClick={() => {
                                    if (
                                        sellerSliderPos + 1 <
                                        appliances.length
                                    ) {
                                        setSellerSliderPos(sellerSliderPos + 1);
                                    } else setSellerSliderPos(0);
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
        );
    }

    function OurPromotions() {
        const promotionsCms = data?.ourPromotions?.nodes?.[0];
        const promotionActionButton = {
            title: promotionsCms?.attributes?.texte_1?.values?.[0]?.[
                currentLocale
            ],
            hasArrow: true,
            onClick: () => navigateTranslated(`/promotions`),
        };

        return (
            <ImageBlock
                title={promotionsCms.title?.[currentLocale]}
                content={promotionsCms?.description?.[currentLocale]}
                image={
                    promotionsCms?.fields?.images?.[0]?.childImageSharp
                        ?.gatsbyImageData
                }
                button={promotionActionButton}
                className='our-promotions'
            />
        );
    }

    function TipsAndTricks() {
        const blogsCms = data?.blogs?.nodes;
        return (
            <div className='best-sellers-container'>
                <PageTitle notHeader title={t('search.tips-and-tricks')} />
                <div className='blogs-list'>
                    {blogsCms?.map((blog: any, index: number) => {
                        if (isMobile && index > 0) return;
                        return (
                            <SingleBlog
                                blog={blog}
                                key={`home-blog-archives-${index}`}
                            />
                        );
                    })}
                </div>
                <div className='show-all'>
                    <EnglanderButton
                        label={t('home.show-all')}
                        iconRight={rightArrowIconLong}
                        className='show-all-btn'
                        onClick={() => {
                            navigateTranslated('/blogArchives/');
                        }}
                    />
                </div>
            </div>
        );
    }

    function OwnerOfEnglander() {
        return (
            <div className='owner-of-englander'>
                <div className='left-section'>
                    <span>{t('home.owner-of-an-englander')}</span>
                </div>
                <div className='right-section'>
                    <div className='section-top'>
                        <EnglanderButton
                            label={t('home.find-replacement')}
                            iconRight={rightArrowIconLong}
                            onClick={() => {
                                navigateTranslated('/archives/');
                            }}
                        />
                        <EnglanderButton
                            label={t('home.find-accessories')}
                            iconRight={rightArrowIconLong}
                            onClick={() => {
                                navigateTranslated('/accessories/');
                            }}
                        />
                    </div>
                    <div className='section-bottom'>
                        <EnglanderButton
                            label={t('home.register-warranty')}
                            iconRight={rightArrowIconLong}
                            onClick={() => {
                                navigateTranslated('/warranty-registration/');
                            }}
                        />
                        <EnglanderButton
                            label={t('home.manuals')}
                            iconRight={rightArrowIconLong}
                            onClick={() => {
                                navigateTranslated('/archives/');
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
